import { render, staticRenderFns } from "./AffWidgets.vue?vue&type=template&id=119e2f0f&scoped=true&"
import script from "./AffWidgets.vue?vue&type=script&lang=js&"
export * from "./AffWidgets.vue?vue&type=script&lang=js&"
import style0 from "./AffWidgets.vue?vue&type=style&index=0&id=119e2f0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119e2f0f",
  null
  
)

export default component.exports